
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index9hovwIgafFI_45mdslbPIKkfJji4G2qfsaCzcfUSvjRK4Meta } from "D:/laragon/www/dabminton/halaman-admin/pages/index.vue?macro=true";
import { default as registerpFn_45Fz2I8g7N9VoPufJdliITLBN1KT4WJ_WnNnsASK4Meta } from "D:/laragon/www/dabminton/halaman-admin/pages/register.vue?macro=true";
import { default as _91id_9326giM_457jyfisnU0eaCm9p1yuTKfKzN_gVVQjO07vJSMMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/roles/[id].vue?macro=true";
import { default as form8PrA7gHllHuLyeX3k_afvKwbz_lFT_45NgVbzCggPbTKQMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/roles/form.vue?macro=true";
import { default as _91id_93s1ETWAF1l6g_45p2ooXibVQ_06rPQfFq8GVS0uFLI1rCwMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/users/[id].vue?macro=true";
import { default as form06K2in_450fZtkYr_45BScrqd_45XaOwKHNcV9k5l0fCBFluUMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/users/form.vue?macro=true";
import { default as _91id_93lcTUku7R6m7SpYicGeNBb_45DYtuobqIq3iyrip1y71K4Meta } from "D:/laragon/www/dabminton/halaman-admin/pages/banner/[id].vue?macro=true";
import { default as formIDYB3EMS7eg66wR9giu5qHab57p6SWIfoDKRDaONS6IMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/banner/form.vue?macro=true";
import { default as _91id_93C6NFt2MsxggX6t0mIp95PstMQjRwDS0iKcTWst_45NUEkMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/jadwal/[id].vue?macro=true";
import { default as form7Qh3bHPp1P3tlMIKbwIXVm52vOgozbzrR7xIkTy1QekMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/jadwal/form.vue?macro=true";
import { default as _91id_93dnlwxmVY3L5XHnd6CBkgGd2_fgPXPVjh929f9OweJxkMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/produk/[id].vue?macro=true";
import { default as form2COtg4AzOpdO9QL47liVaj5cv3coI0nv90DUX4I7i0IMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/produk/form.vue?macro=true";
import { default as index_eR7S__emyQ9u0CmlqmilPTvUvsvrImxW4iq_45fqbs5IMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/roles/index.vue?macro=true";
import { default as indexAy_45Fy6KfjBwlSaHtDK3gIv41F7AUxxTaUWsmP7DkpgUMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/users/index.vue?macro=true";
import { default as indexyFuD_45zastVyAWXF13ouBRfHx2LFNoCRQbDOl6M4TXvkMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/banner/index.vue?macro=true";
import { default as indexqrQ4pi7qHPmVZ3ECxK0UPtyUc8s0zT7dpDIH18sm_45CYMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/jadwal/index.vue?macro=true";
import { default as indexvbBWRbyOYwA_45M8uS0OfzSUvc2w9bPJO3c4TsaoiF3dkMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/produk/index.vue?macro=true";
import { default as _91id_93uqVfrJUaevI_45TKRghLZbLtNo_45mTh7UdVG6fA8WdAF9oMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/lapangan/[id].vue?macro=true";
import { default as form_45pU8Q8qb90583ugVdstU7s_45yfzK3DwsmYyU03foS9E4Meta } from "D:/laragon/www/dabminton/halaman-admin/pages/lapangan/form.vue?macro=true";
import { default as indexJfA8mdoNVI6_n_45lDL9vJOSsOGidBeHEp81KZzXISwOUMeta } from "D:/laragon/www/dabminton/halaman-admin/pages/lapangan/index.vue?macro=true";
import { default as indextAybymJFED_kO3kRsyY7qrl9LVtlpzZ1U55zyQf3U84Meta } from "D:/laragon/www/dabminton/halaman-admin/pages/dashboard/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/register.vue")
  },
  {
    name: "roles-id",
    path: "/roles/:id()",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/roles/[id].vue")
  },
  {
    name: "roles-form",
    path: "/roles/form",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/roles/form.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/users/[id].vue")
  },
  {
    name: "users-form",
    path: "/users/form",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/users/form.vue")
  },
  {
    name: "banner-id",
    path: "/banner/:id()",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/banner/[id].vue")
  },
  {
    name: "banner-form",
    path: "/banner/form",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/banner/form.vue")
  },
  {
    name: "jadwal-id",
    path: "/jadwal/:id()",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/jadwal/[id].vue")
  },
  {
    name: "jadwal-form",
    path: "/jadwal/form",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/jadwal/form.vue")
  },
  {
    name: "produk-id",
    path: "/produk/:id()",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/produk/[id].vue")
  },
  {
    name: "produk-form",
    path: "/produk/form",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/produk/form.vue")
  },
  {
    name: "roles",
    path: "/roles",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/roles/index.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/users/index.vue")
  },
  {
    name: "banner",
    path: "/banner",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/banner/index.vue")
  },
  {
    name: "jadwal",
    path: "/jadwal",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/jadwal/index.vue")
  },
  {
    name: "produk",
    path: "/produk",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/produk/index.vue")
  },
  {
    name: "lapangan-id",
    path: "/lapangan/:id()",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/lapangan/[id].vue")
  },
  {
    name: "lapangan-form",
    path: "/lapangan/form",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/lapangan/form.vue")
  },
  {
    name: "lapangan",
    path: "/lapangan",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/lapangan/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("D:/laragon/www/dabminton/halaman-admin/pages/dashboard/index.vue")
  }
]